import { EnumLoginSecureKeyTypes } from '@m4u-angular/core/framework/sysenums.enum';
import { InvoiceOneDocumentCodeParams } from '@dato-proxy/params/invoiceonedocumentcode.param';
import { EnumLoginRequestTypes } from '@dato-proxy/enums';
import { LoginService } from '@m4u-angular/core/framework/login.service';
import { LoginRequest } from '@dato-proxy/entities/loginrequest.entity';
import { LoginRequestEndpoint } from '@dato-proxy/endpoints/loginrequest.endpoint';
import { ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState, BaseEntityResponse, LoginParams, SessionEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { Component } from '@angular/core';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { Globals } from '../../_globals';
import { LanguageService } from '@m4u-angular/core/framework/language.service';

class State extends BaseState {
    Language: string;
}
@Component({
    providers: ServiceBagServices,
    selector: 'go-from-document-code',
    templateUrl: './go-from-document-code.component.html',
    styleUrls: ['./go-from-document-code.component.scss']
})
export class GoFromDocumentCodeComponent extends BasePageComponent<BaseEntity, State> {

    constructor(A: ServiceBagService,
        private loginRequestEndpoint: LoginRequestEndpoint,
        private loginService: LoginService,
        private languageService: LanguageService) {
        super(A, 'GoFromDocumentCodeComponent', BaseEntity, State);
    }

    override OnInitComponent() {
        // Getting document number from query params
        const DocumentCode = this.QueryParams.DocumentCode;
        const IsGoToPersonalDetails = this.QueryParams.IsGoToPersonalDetails;
        this.State.Language = this.QueryParams.Language;
        this.A.Navigator.ClearQueryParams();

        // Checking pdf link
        if (!DocumentCode) {
            this.A.UI.StopMessage(this.RC('msgErrorDocumentCodeNotValid'));
            this.A.Navigator.Navigate(['/system/login']);
            return;
        }

        // Handling a language
        if (this.State.Language) { this.languageService.SetLanguage(this.State.Language); }

        // Creating Params
        const Params = new InvoiceOneDocumentCodeParams();
        Params.DocumentCode = DocumentCode;
        Params.IsGoToPersonalDetails = IsGoToPersonalDetails;

        this.Do(this.loginRequestEndpoint.CreateByInvoiceOneCode(Params), false,
            (response: BaseEntityResponse<LoginRequest>) => { this.OnCreateLoginRequestSuccess(response); },
            (response: BaseEntityResponse<LoginRequest>) => {
                this.A.UI.StopMessage(response.ResponseMessage);
                this.A.Navigator.Navigate(['/system/login']);
            }

        );
    }

    private OnCreateLoginRequestSuccess(response: BaseEntityResponse<LoginRequest>) {
        // Create Params
        const oLoginParams = new LoginParams();
        oLoginParams.UserName = response.Entity.UserName;
        oLoginParams.SecureKey = response.Entity.OTP;
        oLoginParams.SecureKeyType = EnumLoginSecureKeyTypes.Password;

        if (this.State.Language) { oLoginParams.Language = this.State.Language; }

        // Login
        this.loginService.DoLogin(oLoginParams, false, false, () => {
            if (response.Entity.Type === EnumLoginRequestTypes.Payment) {
                if (Globals.IsAllowAccounting() || Globals.SystemOption.IsAllowMyDetails) {
                    this.Navigate([`/pages/pdf_view/${response.Entity.EntryID}`]);
                } else {
                    this.Navigate([`/pages/pdf_view_np/${response.Entity.EntryID}`]);
                }
            } else if (response.Entity.Type === EnumLoginRequestTypes.PersonDetails) {
                this.Navigate(['/pages/my-details']);
            } else {
                this.Navigate(['/pages/reports'], { Tab: 2 });
            }
        }, (responseSession: BaseEntityResponse<SessionEntity>) => {
            this.A.UI.StopMessage(responseSession.ResponseMessage);
            this.A.Navigator.Navigate(['/system/login']);
        }).subscribe(() => {});;
    }
}
